import React from "react";

export default function TermsConditions() {
  return (
    <div style={{ maxWidth: "900px", margin: "40px auto", padding: "20px" }}>
      <h1>Terms & Conditions</h1>

      <p>
        Welcome to KaamHub. By using our platform, you agree to these Terms &
        Conditions.
      </p>

      <h2>Service Booking</h2>
      <p>
        Customers can book verified service professionals through the KaamHub
        platform.
      </p>

      <h2>User Responsibilities</h2>
      <ul>
        <li>Provide accurate booking information.</li>
        <li>Respect service professionals.</li>
        <li>Do not misuse the platform.</li>
      </ul>

      <h2>Partner Responsibilities</h2>
      <ul>
        <li>Provide quality service.</li>
        <li>Arrive on time.</li>
        <li>Follow KaamHub policies.</li>
      </ul>

      <h2>Payments</h2>
      <p>
        Payments are processed securely through our supported payment methods.
      </p>

      <h2>Limitation of Liability</h2>
      <p>
        KaamHub acts as a platform connecting customers and service partners.
      </p>

      <h2>Contact</h2>
      <p>Email: support@kaamhub.in</p>
      <p>Website: https://kaamhub.in</p>

      <p>Last Updated: July 2026</p>
    </div>
  );
}
